export const fixErrorStack = <E>(error: E, stack: string | undefined, framesToRemove: number) => {
  if (error instanceof Error && stack) {
    const callerStack = stack.split('\n').slice(framesToRemove)
    const [errName, ...restStack] = error?.stack?.split('\n') ?? ['Unknown Error']
    error.stack = [errName, ...callerStack, ...restStack].join('\n')
  }
  return error
}
